module.exports = __webpack_public_path__ + "static/media/LWC-PRESS2.f1e5c15f.png";